import { render, staticRenderFns } from "./About-old.vue?vue&type=template&id=40b42f92&"
import script from "./About-old.vue?vue&type=script&lang=ts&"
export * from "./About-old.vue?vue&type=script&lang=ts&"
import style0 from "./About-old.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports